export var EPropertyFetchType;
(function (EPropertyFetchType) {
    EPropertyFetchType["All"] = "ALL";
    EPropertyFetchType["Owned"] = "OWNED";
    EPropertyFetchType["Rented"] = "RENTED";
    EPropertyFetchType["Archived"] = "ARCHIVED";
})(EPropertyFetchType || (EPropertyFetchType = {}));
